import React, { useState } from "react";
import { toast } from "react-toastify";
import { ModalSearchClienteH } from "./ModalSearchClienteH";
import { ApiService } from "../ApiService";
import { useParams } from "react-router-dom";

export const ModalNuevoClienteH = ({ isOpen, onClose, reset_data, keyBranch }) => {
	const { authCode } = useParams();

	const [selectedUserName, setSelectedUserName] = useState([]);
	const [descuento, setDescuento] = useState("");
	const [selectedUserError, setSelectedUserError] = useState(false);
	const [descuentoError, setDescuentoError] = useState(false);
	const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

	if (!isOpen) return null;

	const handleOpenSearchModal = () => {
		setIsSearchModalOpen(true);
	};

	const handleCloseSearchModal = () => {
		setIsSearchModalOpen(false);
	};

	const handleUserSelect = (user) => {
		setSelectedUserName(user);
		setSelectedUserError(false);
		handleCloseSearchModal();
	};

	const handleKeyDown = (e) => {
		if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
			e.preventDefault();
		}
	};

	async function saveDiscount(e) {
		e.preventDefault();
		if (!selectedUserName || descuento < 0 || descuento > 100 || !descuento)
			toast.error("Debe completar el formulario antes de guardar");

		const body_request = {
			auth_code: selectedUserName.authCode,
			discount: parseInt(descuento),
		};

		const response = await ApiService.fetchData(`api/company/clients/add-discount?key_branch=${keyBranch}`, {
			method: "POST",
			body: JSON.stringify(body_request),
		});

		const data = await response;

		if (data == null) {
			toast.error("Error de solicitud");
		} else {
			setSelectedUserName([]);
			setDescuento("");

			toast.success(data.message);
			onClose();
			reset_data();
		}
	}

	return (
		<div className="modal-overlay-old">
			<div className="modal-container-old">
				<div className="modal-header-old">
					<h2 className="modal-title">Nuevo Cliente Hosming</h2>
					<button className="close-modal-btn" onClick={onClose}>
						✖
					</button>
				</div>

				<form
					onSubmit={(e) => {
						saveDiscount(e);
					}}>
					<div className="modal-body">
						{/* Selección de cliente */}
						<div className="form-group">
							<label className="txt-name-category" htmlFor="usuario">
								Cliente<span className="obligate">*</span>
							</label>
							<div style={{ display: "flex", flexDirection: "row" }}>
								<input
									className={`modal-input-old ${selectedUserError ? "input-error" : ""}`}
									type="text"
									readOnly
									value={selectedUserName.fullName}
									placeholder="Seleccione cliente"
									onClick={handleOpenSearchModal}
									style={{ cursor: "pointer" }}
								/>
							</div>
						</div>

						{/* Campo de descuento */}
						<div className="form-group">
							<label className="txt-name-category" htmlFor="clienteDescuento">
								Descuento %<span className="obligate">*</span>
							</label>
							<div style={{ display: "flex", alignItems: "center" }}>
								<input
									className={`modal-input-old ${descuentoError ? "input-error" : ""}`}
									type="number"
									id="clienteDescuento"
									name="clienteDescuento"
									placeholder="Ingrese el descuento"
									value={descuento}
									onChange={(e) => setDescuento(e.target.value)}
									onKeyDown={handleKeyDown}
									style={{ width: "100%" }}
								/>
							</div>
						</div>
					</div>

					<div className="modal-footer">
						<button type="button" className="cancel-button-product" onClick={onClose}>
							Cancelar
						</button>
						<button type="submit" className="save-button" onClick={saveDiscount}>
							Guardar
						</button>
					</div>
				</form>
			</div>

			{/* Modal de búsqueda de cliente */}
			<ModalSearchClienteH
				isOpen={isSearchModalOpen}
				onClose={handleCloseSearchModal}
				onUserSelect={handleUserSelect} // Corregido: se usa onUserSelect
			/>
		</div>
	);
};
